import Servico from './Servico'

class FaturamentoServico extends Servico {
  constructor() {
    super('faturamento')
  }
}

export default FaturamentoServico
